import React from 'react';

type Variant = 'success' | 'warning' | 'danger' | 'info' | 'accent' | 'purple' | 'default';

const variantMap: Record<Variant, string> = {
  success: 'badge-success',
  warning: 'badge-warning',
  danger: 'badge-danger',
  info: 'badge-info',
  accent: 'badge-accent',
  purple: 'badge-purple',
  default: 'badge-info',
};

interface BadgeProps {
  label: string;
  variant?: Variant;
  dot?: boolean;
  className?: string;
}

const Badge: React.FC<BadgeProps> = ({ label, variant = 'default', dot = false, className = '' }) => (
  <span className={`badge ${variantMap[variant]} ${className}`}>
    {dot && <span className="w-1.5 h-1.5 rounded-full bg-current" />}
    {label}
  </span>
);

export default Badge;
